import React from "react";
import LogoBg from "../../Images/logo.png";

const Logo = () => <img className="logo" src={LogoBg} alt="logo" />;

export default Logo;
